import React, { FC } from 'react';
import useCountdown from '@/hooks/useCountDown';

type Props = {
  startTime: number;
  endTime: number;
  className?: string;
  noHour?: boolean;
  showDay?: boolean;
  countEndCallback?: () => void;
};
const TimeCountDown: FC<Props> = ({
  startTime,
  endTime,
  className,
  countEndCallback,
  noHour = false,
  showDay = true
}) => {
  const { timeString } = useCountdown(() => endTime as number, {
    noHour: noHour,
    start: () => startTime || Date.now() / 1000,
    onEnd: () => {
      if (countEndCallback) {
        countEndCallback();
        return;
      }
      location.reload();
    },
    showDay: showDay
  });
  if (noHour) {
    return <span data-testid="wid-time-count-down" dangerouslySetInnerHTML={{ __html: timeString }} />;
  }
  return (
    <span data-testid="wid-time-count-down" className={className}>
      {timeString}
    </span>
  );
};

export default TimeCountDown;
